import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * The autocomplete list itself (recent / videos / categories / popular).
 * Positioning is the parent's job; keyboard handling stays in the parent too,
 * which only feeds `activeIndex` and listens to `select`.
 */
@Component({
  standalone: false,
  selector: 'app-search-suggest-list',
  templateUrl: './search-suggest-list.component.html',
  styleUrls: ['./search-suggest-list.component.scss']
})
export class SearchSuggestListComponent {
  @Input() items: any[] = [];
  @Input() activeIndex = -1;
  @Input() query = '';
  @Input() loading = false;
  @Input() showSeeAll = true;
  @Output() select = new EventEmitter<any>();
  @Output() activate = new EventEmitter<number>();
  @Output() remove = new EventEmitter<any>();
  @Output() clear = new EventEmitter<void>();
  @Output() seeAll = new EventEmitter<void>();

  defaultThumb = 'https://dyo1wwfvu9av7.cloudfront.net/jkp/common/default-poster.png';

  hasQuery(): boolean {
    return !!(this.query && String(this.query).trim().length > 0);
  }

  onRemove(item: any, event: Event) {
    event.stopPropagation();
    this.remove.emit(item);
  }

  onClear(event: Event) {
    event.stopPropagation();
    this.clear.emit();
  }
}
